import React, { PropTypes } from 'react';
import { FormControl, Col, ControlLabel, FormGroup } from 'react-bootstrap';

const SumInsured = (props) => {
  return (
    <FormGroup>
      <Col componentClass={ControlLabel} sm={5}>
        Sum Insured
      </Col>
      <Col sm={7}>
          <FormControl
            name="sumInsured"
            type="number"
            step="1"
            max="99999999"
            min="0"
            value={props.sumInsured}
            onChange={props.handleChangeSumInsured}
            onBlur={() => props.validation(true)}
            autoComplete="off"
             />
      </Col>
    </FormGroup>
  )
}

SumInsured.propTypes = {
  sumInsured: PropTypes.number,
  handleChangeSumInsured: PropTypes.func,
  validation: PropTypes.func
};

export default SumInsured;



// WEBPACK FOOTER //
// ./src/app/components/quotationPVComponent/sumInsured/SumInsured.js